import { NgClass, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { StorageType } from 'mbs-ui-shared@models';
import { StorageDisplayNamePipe } from 'mbs-ui-shared@utils/pipes/storage-display-name.pipe';

type StorageTypeImage = { name: string; path: string; helpPage: string };
const defaultImage = 'supported-storage';

@Component({
  selector: 'mbs-storage-icons',
  templateUrl: './storage-icons.component.html',
  styleUrls: ['./storage-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StorageDisplayNamePipe],
  imports: [NgClass, NgForOf],
  standalone: true
})
export class StorageIconsComponent implements OnInit {
  @Input() alignClasses: string | string[] = ['justify-content-center', 'align-items-center'];
  @Input() storages: StorageType[] = [
    StorageType.AmazonS3,
    StorageType.AzureVM,
    StorageType.BackblazeB2,
    StorageType.Wasabi,
    StorageType.LocalFS,
    StorageType.Google,
    StorageType.Minio,
    StorageType.S3Compatible
  ];
  public storageList: StorageTypeImage[] = [];

  constructor(private storageDisplayNamePipe: StorageDisplayNamePipe) {}

  ngOnInit(): void {
    this.storages.forEach((storage) => {
      switch (storage) {
        case StorageType.AmazonS3Apps:
          this.storageList.push(this.createImage(StorageType.AmazonS3Apps, 'amazon/sign-up-amazon-s3'));
          break;
        case StorageType.AmazonS3:
          this.storageList.push(this.createImage(StorageType.AmazonS3, 'amazon/sign-up-amazon-s3'));
          break;
        case StorageType.Azure:
          this.storageList.push(this.createImage(StorageType.Azure, 'azure/sign-up-for-microsoft-azure'));
          break;
        case StorageType.AzureVM:
          this.storageList.push(this.createImage(StorageType.AzureVM, 'azure/sign-up-for-microsoft-azure'));
          break;
        case StorageType.BackblazeB2:
          this.storageList.push(this.createImage(StorageType.BackblazeB2, 'b2/sign-up-for-backblaze-b2'));
          break;
        case StorageType.Google:
          this.storageList.push(this.createImage(StorageType.Google, 'google-cloud/sign-up-for-google-cloud'));
          break;
        case StorageType.LocalFS:
          this.storageList.push(this.createImage(StorageType.LocalFS, defaultImage));
          break;
        case StorageType.Minio:
          this.storageList.push(this.createImage(StorageType.Minio, defaultImage));
          break;
        case StorageType.S3Compatible:
          this.storageList.push(this.createImage(StorageType.S3Compatible, defaultImage));
          break;
        case StorageType.Wasabi:
          this.storageList.push(this.createImage(StorageType.Wasabi, 'wasabi/wasabi-signup'));
          break;
        // ... add below route for display new svg icon by condition

        default:
          throw new Error('Caught error manually: Unsupported storage type');
      }
    });
  }

  private createImage(storageType: StorageType, helpPage: string): StorageTypeImage {
    const getPath = (type) => (type === StorageType.AmazonS3Apps ? StorageType[StorageType.AmazonS3] : StorageType[storageType]);

    return {
      path: 'assets/images/storages/' + getPath(storageType).toString() + '.svg',
      helpPage: 'billing-storage/storage-providers/' + helpPage,
      name: this.storageDisplayNamePipe.transform(storageType)
    };
  }
}
